class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    // Delegate to the wrapper because section rendering replaces the link.
    cartIcon.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartIcon.querySelector('a'));
    });
    cartIcon.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartIcon.querySelector('a'));
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    clearTimeout(this.openTimer);
    clearTimeout(this.focusTimer);
    this.openTimer = setTimeout(() => {
      this.classList.add('animate', 'active');
      this.setExpanded(true);
      // Match the drawer's visibility transition; also works without transitionend.
      const styles = getComputedStyle(this);
      const duration = parseFloat(styles.transitionDuration) || 0;
      const delay = parseFloat(styles.transitionDelay) || 0;
      this.focusTimer = setTimeout(() => {
        if (!this.classList.contains('active')) return;
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = containerToTrapFocusOn.querySelector('button') || this.querySelector('.drawer__inner');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, (duration + delay) * 1000 + 50);
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.focusTimer);
    this.classList.remove('active');
    this.setExpanded(false);
    const returnFocus = this.activeElement && this.activeElement.isConnected
      ? this.activeElement
      : document.querySelector('#cart-icon-bubble a');
    removeTrapFocus(returnFocus);
    document.body.classList.remove('overflow-hidden');
  }

  setExpanded(expanded) {
    const cartLink = document.querySelector('#cart-icon-bubble a');
    if (cartLink) cartLink.setAttribute('aria-expanded', expanded);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  onCartUpdate(event) {
    // ProductForm renders the drawer from the add response itself.
    if (event.source !== 'product-form') super.onCartUpdate(event);
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
    if (document.getElementById('main-cart-items')) {
      sections.push(...super.getSectionsToRender().filter((section) =>
        section.id !== 'cart-icon-bubble' && section.id !== 'CartDrawer'
      ));
    }
    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
